// extracted by mini-css-extract-plugin
export default {"sm":"min-width: 1024px","masterlegend":"Legend_masterlegend__mlhoB","palestinianRow":"Legend_palestinianRow__HqC3z","dot":"Legend_dot__JAUjF","mapLegend":"Legend_mapLegend__5TyTG"};